import { all } from "redux-saga/effects";
import { authSaga } from "./auth/authSaga";
import bienLaiSagaWrapper from "./bien-lai/bienLaiSagaWrapper";
import categorySagaWrapper from "./category/categorySaga";
import lopTinChiSagaWrapper from "./lop-tin-chi/lopTinChiWrapper";
import mienGiamSaga from "./mien-giam/mienGiamSaga";
import troCapSaga from "./tro-cap/troCapSaga";
import mucThuSagaWrapper from "./muc-thu/mucThuSagaWrapper";
import reportSagaWrapper from "./report/reportSagaWrapper";
import thuPhiSagaWrapper from "./thu-phi/thuPhiSagaWrapper";
import baoCaoSagaWrapper from "./bao-cao/baoCaoSagaWrapper";
import { nofiticationSaga } from "./nofitication/nofiticationSaga";
import hoaDonSagaWrapper from "./hoa-don/hoaDonSagaWrapper";
import { bieuDoSaga } from "./bieu-do/bieuDoSaga";
import { thongKeCanXuLySaga } from "./dashboard/thongKeCanXuLySaga";
import nganHangSaga from "./ngan-hang/nganHangSaga";
import dongBoSagaWrapper from "./dong-bo/dongBoSagaWrapper";
import thietLapSagaWrapper from "./thiet-lap/thietLapSaga";
import dichVuSaga from "./dich-vu/dichVuSaga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    categorySagaWrapper(),
    mucThuSagaWrapper(),
    mienGiamSaga(),
    troCapSaga(),
    thuPhiSagaWrapper(),
    bienLaiSagaWrapper(),
    reportSagaWrapper(),
    lopTinChiSagaWrapper(),
    baoCaoSagaWrapper(),
    hoaDonSagaWrapper(),
    bieuDoSaga(),
    thongKeCanXuLySaga(),
    nganHangSaga(),
    dongBoSagaWrapper(),
    thietLapSagaWrapper(),
    dichVuSaga(),
    nofiticationSaga(),
  ]);
}
